import {
    api_deleteAnimal,
    api_editAnimal,
    api_getPetsList,
    api_getPetURLUploadImage,
    api_setAnimal,
    api_getNotesForPet,
    api_getPetByID
} from "./pets.api";
import {setPetsList, addPet, removePet, setSelectedPet, setPetImageURL} from "./pets.reducers";

export const getPetsList = params => dispatch => (
    api_getPetsList(params).then(res => {
        dispatch(setPetsList(
            (Array.isArray(res) && res.length)
                ? res
                : []
        ));
        return res;
    })
);

export const setAnimal = params => dispatch => (
    api_setAnimal(params).then(res => {
        dispatch(addPet(res));
    })
);

export const deleteAnimal = params => dispatch => (
    api_deleteAnimal(params).then(res => {
        dispatch(removePet(res));
        return res;
    })
);

export const editAnimal = (id, body) => dispatch => (
    api_editAnimal(id, body).then(res => {
        dispatch(setSelectedPet(res));
    })
);

export const getPetURLUploadImage = params => dispatch => (
    api_getPetURLUploadImage(params).then(res => {
        dispatch(setPetImageURL(res.downloadUrl));
        return res;
    })
);

export const setSelectedAnimal = pet => dispatch => (
    dispatch(setSelectedPet(pet))
);

export const getPetByID = id => dispatch => (
    api_getPetByID(id).then(res => {
        dispatch(setSelectedPet(res));
        return res;
    })
);

export const getNotesForPet = id => dispatch => (
    api_getNotesForPet(id).then(res => {
        return res;
    })
);